import CopyrightFooter from "./CopyrightFooter";
import {Link} from "react-router-dom";
import ScrollToTop from "./ScrollTop";
import React from "react";
import {Col, Row} from "react-bootstrap";
import Social from "../../components/footer/common-footer/Social";

const FooterBlock = () => {
  return (
    <footer className="main-footer">
      <div className="auto-container">
        <div className="widgets-section" data-aos="fade-up">
            <Row>
                <Col lg={3} md={12} sm={12} className={'align-content-center'}>
                    <div className="footer-column about-widget mb-3">
                        <div className="logo" style={{marginBottom : "15px"}}>
                            <Link to="/">
                                <img
                                    width={257}
                                    src="/images/resource/logo-gth.png"
                                    alt="brand"
                                />
                            </Link>
                        </div>
                    </div>
                </Col>

                <Col lg={7} md={12} sm={12} className={'align-content-center'}>
                    <p className={'mb-3'}>
                        Groupe <b>Talents Handicap</b> est la dénomination commerciale de la société NEW NET 3D, créée en 2009, pour mettre le digital et l'innovation au service de l'inclusion et de l'emploi des personnes en situation de handicap, à travers nos différents services : recrutement, marque employeur, formation, sensibilisation, accompagnement...
                    </p>
                </Col>

                <Col lg={2} md={12} sm={12} className={'align-content-center'}>
                    <Social/>
                </Col>
            </Row>
        </div>
      </div>
      <CopyrightFooter/>
      <ScrollToTop/>
    </footer>
  );
};

export default FooterBlock;
